export type Locale = 'ar' | 'en';

export const LOCALES: readonly Locale[] = ['ar', 'en'];

/** Arabic is the default (SRS §2.4); English is the supported alternative. */
export const DEFAULT_LOCALE: Locale = 'ar';

export const DIRECTION: Record<Locale, 'rtl' | 'ltr'> = { ar: 'rtl', en: 'ltr' };

export const LOCALE_NAMES: Record<Locale, string> = { ar: 'العربية', en: 'English' };

/** Each language's short name, written in that language, for the language button. */
export const LOCALE_SHORT_NAMES: Record<Locale, string> = { ar: 'ع', en: 'EN' };

/**
 * A flat message catalogue. Keys are dotted for grouping only; nothing splits on the dot at runtime.
 *
 * Plural forms are separate keys suffixed with a CLDR category — `children.count.one`,
 * `children.count.few` — and gendered forms are suffixed `.male` / `.female`. Both suffixes are resolved
 * by `t`, so a caller never assembles a key by hand and no sentence is built from fragments
 * (NFR-I18N-01, NFR-I18N-04).
 */
export type Messages = Record<string, string>;

export interface Catalogue {
  ar: Messages;
  en: Messages;
}

/** Values interpolated into `{placeholder}` slots. */
export type MessageParams = Record<string, string | number>;

export type Gender = 'Male' | 'Female';
